import { Outlet } from 'react-router-dom';
import { Header } from '@/widgets/Header';
import { Layout } from '@/shared/ui/Layout';
import { SideMenu } from '@/widgets/SideMenu';
import { Footer } from '@/widgets/Footer';
import { classNames } from '@/shared/lib/classNames';
import cls from './MainLaout.module.scss';
import { useAcquiringStore } from '@/pages/AcquiringPage/model/store/useAcquiringStore';

export const MainLayout = () => {
    const { isAcquiring } = useAcquiringStore();
    return (
        <Layout //
            headerSlot={<Header className={classNames('', { [cls.header]: isAcquiring })} />}
            pageSlot={<Outlet />}
            sideMenuSlot={<SideMenu />}
            footerSlot={<Footer />}
        />
    );
};
